// Lenis smooth-scroll singleton + helpers shared across the landing page.
let lenisInstance = null;

export const setLenis = (l) => {
    lenisInstance = l;
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

export const scrollToTop = () => {
    if (lenisInstance) lenisInstance.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
};

// Email CTA — every "Request a Demo" action opens the user's mail client.
export const DEMO_EMAIL = "info@apexprosafety.com";
export const DEMO_MAILTO =
    "mailto:info@apexprosafety.com" +
    "?subject=" +
    encodeURIComponent("Demo Request — Apex Pro") +
    "&body=" +
    encodeURIComponent(
        "Hi Apex Pro team,\n\n" +
            "I'd like to request a demo of the Apex Pro safety reporting platform.\n\n" +
            "Name:\nCompany:\nRole:\nNumber of sites:\nBest time to reach me:\n\n" +
            "Thank you."
    );
